<template>
  <div class="inviteExternalContact">
    <background />
    <img
      v-if="inviteFirend.userHeadImg"
      :src="getImgUrl(inviteFirend.userHeadImg)"
      alt
      class="headerImg"
    />
    <img v-else src="@/assets/imgs/person.svg" alt class="headerImg" />
    <div class="title">{{ inviteFirend.name }}邀请你成为好友</div>
    <div class="des"></div>
    <div class="btn" @click="goUrl('/login?redirect=/inviteFirendHasLogin')">
      没有账号，现在注册
    </div>
    <div
      class="goLogin"
      @click="goUrl('/login?redirect=/inviteFirendHasLogin')"
    >
      已有账号，现在登录
    </div>
  </div>
</template>
<script>
  import Api from '@/api/address'
  import mixin from './mixin'

  export default {
    mixins: [mixin],
    data() {
      return {
        inviteFirend: {},
      }
    },
    created() {
      const { userId, comId } = this.$route.query
      if (window.sessionStorage.getItem('inviteFirend') && !userId) {
        this.inviteFirend = this.$jsonPase(
          window.sessionStorage.getItem('inviteFirend')
        )
        return
      }
      this.getRequestFriendInfo({
        userId,
        comId,
      })
    },
    methods: {
      getRequestFriendInfo(params) {
        Api.getRequestFriendInfo(params).then(res => {
          this.inviteFirend = res
          window.sessionStorage.setItem(
            'inviteFirend',
            JSON.stringify({
              ...this.msg,
              ...res,
            })
          )
        })
      },
      goUrl(url) {
        this.$router.push(url)
      },
    },
  }
</script>
<style lang="less" scoped>
  .inviteExternalContact {
    padding-top: 30px;
    .headerImg {
      display: flex;
      margin: 0 auto;
      margin-bottom: 30px;
      width: 70px;
      height: 70px;
      border: 2px solid rgba(255, 255, 255, 1);
    }
    .title {
      height: 30px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 30px;
      text-align: center;
      margin-bottom: 10px;
    }
    .des {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
      text-align: center;
      margin-bottom: 37px;
    }
    .btn {
      width: 280px;
      height: 45px;
      background: rgba(22, 118, 255, 1);
      border-radius: 23px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 45px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 16px;
    }
    .goLogin {
      height: 21px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(22, 118, 255, 1);
      line-height: 21px;
      text-align: center;
    }
  }
</style>
